import gql from 'graphql-tag';

export default gql`
    query getAssetsForResource($resourceId: String!, $organisationId: String!) {
        getAssetsForResource(resourceId: $resourceId, organisationId: $organisationId) {
            assetId
            organisationId
            filename
            title
            description
            createdAt
            updatedAt
            altText
            metaData
            createdByUser {
              userId
              firstName
              lastName
            }
            assetRelations {
              assetRelationId
              assetId
              relatedToId
            }
            assetFiles {
                ORIGINAL {
                    assetFileId
                    type
                    status
                    sourceUrl
                },
                THUMBNAIL {
                    assetFileId
                    type
                    status
                    sourceUrl
                },
                HD {
                    assetFileId
                    type
                    status
                    sourceUrl
                },
                SD {
                    assetFileId
                    type
                    status
                    sourceUrl
                },
                CAPTION {
                    assetFileId
                    type
                    status
                    sourceUrl
                    metaData
                },
                VTT_CAPTION {
                    assetFileId
                    type
                    status
                    sourceUrl
                    metaData
                }
            }
        }
    }
`;